export enum NOTIFICATION_TYPE {
    EXCEL = 'excel',
    INFO = 'info',
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
}

export const NOTIFICATION_DURATION = 3000;
